import React from "react"

import { TweenMax, Expo, Quart } from "gsap"
import data from "./data/data.json"

import imgWater1BG from "./assets/share/shareWater1BG.png"
import imgWater2BG from "./assets/share/shareWater2BG.png"
import imgWater3BG from "./assets/share/shareWater3BG.png"
import imgFanWater1BG from "./assets/share/shareFanWater1BG.png"
import imgFanWater2BG from "./assets/share/shareFanWater2BG.png"
import imgFanWater3BG from "./assets/share/shareFanWater3BG.png"

import imgLand1BG from "./assets/share/shareLand1BG.png"
import imgLand2BG from "./assets/share/shareLand2BG.png"
import imgLand3BG from "./assets/share/shareLand3BG.png"
import imgFanLand1BG from "./assets/share/shareFanLand1BG.png"
import imgFanLand2BG from "./assets/share/shareFanLand2BG.png"
import imgFanLand3BG from "./assets/share/shareFanLand3BG.png"

import imgAir1BG from "./assets/share/shareAir1BG.png"
import imgAir2BG from "./assets/share/shareAir2BG.png"
import imgAir3BG from "./assets/share/shareAir3BG.png"
import imgFanAir1BG from "./assets/share/shareFanAir1BG.png"
import imgFanAir2BG from "./assets/share/shareFanAir2BG.png"
import imgFanAir3BG from "./assets/share/shareFanAir3BG.png"

import audioJungle from "./assets/jungle.mp3"

class SliderView extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      value: 0,
      unit: 0,
      airIndex: 0,
      landIndex: 0,
      waterIndex: 0,
      tooltipState: "edit",
      scale: 20000,
      scaleIndex: 0,
      width: 0,
    }
  }

  componentDidMount() {
    var that = this

    this.audioSrc = audioJungle

    this.setState({ width: window.innerWidth })

    this.sliderWidth = 700

    this.currX = 0

    this.thumbEl.addEventListener("mousedown", function(e) {
      that.orX = e.clientX
      that.orCurrX = that.currX
    })

    this.thumbEl.addEventListener("touchstart", function(e) {
      that.orX = e.touches[0].clientX
      that.orCurrX = that.currX
    })

    window.addEventListener("mousemove", function(e) {
      if (that.orX) {
        var deltaX = e.clientX - that.orX

        if (deltaX + that.orCurrX < 0) {
          deltaX = -that.orCurrX
        }

        if (deltaX + that.orCurrX > that.sliderWidth) {
          deltaX = that.sliderWidth - that.orCurrX
        }

        that.currX = deltaX + that.orCurrX

        TweenMax.set(that.thumbEl, { x: that.currX })

        that.props.callback(that.currX / that.sliderWidth)
        that.updateValue()
      }
    })

    window.addEventListener("touchmove", function(e) {
      if (that.orX) {
        var deltaX = e.touches[0].clientX - that.orX

        if (deltaX + that.orCurrX < 0) {
          deltaX = -that.orCurrX
        }

        if (deltaX + that.orCurrX > that.sliderWidth) {
          deltaX = that.sliderWidth - that.orCurrX
        }

        that.currX = deltaX + that.orCurrX

        TweenMax.set(that.thumbEl, { x: that.currX })

        that.props.callback(that.currX / that.sliderWidth)
        that.updateValue()
      }
    })

    window.addEventListener("mouseup", function(e) {
      that.orX = null
    })

    window.addEventListener("touchend", function(e) {
      that.orX = null
    })

    window.addEventListener("click", function(e) {
      if (
        !e.target.classList.contains("tooltip-input") &&
        !e.target.classList.contains("tooltip-arrow") &&
        that.tooltipEl.classList.contains("edit")
      ) {
        that.tooltipEl.classList.remove("edit")
        that.tooltipEl.classList.remove("editing")
        that.inputEl.value = ""
      }

      if (
        !e.target.classList.contains("stat-value") &&
        (that.stat1El.classList.contains("active") ||
          that.stat2El.classList.contains("active") ||
          that.stat3El.classList.contains("active"))
      ) {
        that.stat1El.classList.remove("active")
        that.stat2El.classList.remove("active")
        that.stat3El.classList.remove("active")
      }
    })

    //Set water share images
    this.waterCtx = this.waterCanvas.getContext("2d")

    this.water1Img = new Image()
    this.water1Img.onload = function() {
      that.updateWaterCanvas()
    }
    this.water1Img.src = imgWater1BG

    this.water2Img = new Image()
    this.water2Img.src = imgWater2BG

    this.water3Img = new Image()
    this.water3Img.src = imgWater3BG

    this.waterFan1Img = new Image()
    this.waterFan1Img.src = imgFanWater1BG

    this.waterFan2Img = new Image()
    this.waterFan2Img.src = imgFanWater2BG

    this.waterFan3Img = new Image()
    this.waterFan3Img.src = imgFanWater3BG

    this.waterImgs = []
    this.waterImgs.push({ img: this.water1Img, textY: 583 })
    this.waterImgs.push({ img: this.water2Img, textY: 616 })
    this.waterImgs.push({ img: this.water3Img, textY: 583 })

    this.waterFanImgs = []
    this.waterFanImgs.push({ img: this.waterFan1Img, textY: 582 })
    this.waterFanImgs.push({ img: this.waterFan2Img, textY: 616 })
    this.waterFanImgs.push({ img: this.waterFan3Img, textY: 616 })

    this.waterShareData = [this.waterImgs, this.waterFanImgs]

    this.waterShareData = [this.waterImgs, this.waterFanImgs]

    //Set land share images
    this.landCtx = this.landCanvas.getContext("2d")

    this.land1Img = new Image()
    this.land1Img.onload = function() {
      that.updateLandCanvas()
    }
    this.land1Img.src = imgLand1BG

    this.land2Img = new Image()
    this.land2Img.src = imgLand2BG

    this.land3Img = new Image()
    this.land3Img.src = imgLand3BG

    this.landFan1Img = new Image()
    this.landFan1Img.src = imgFanLand1BG

    this.landFan2Img = new Image()
    this.landFan2Img.src = imgFanLand2BG

    this.landFan3Img = new Image()
    this.landFan3Img.src = imgFanLand3BG

    this.landImgs = []
    this.landImgs.push({ img: this.land1Img, textY: 583 })
    this.landImgs.push({ img: this.land2Img, textY: 583 })
    this.landImgs.push({ img: this.land3Img, textY: 624 })

    this.landFanImgs = []
    this.landFanImgs.push({ img: this.landFan1Img, textY: 548 })
    this.landFanImgs.push({ img: this.landFan2Img, textY: 548 })
    this.landFanImgs.push({ img: this.landFan3Img, textY: 548 })

    this.landShareData = [this.landImgs, this.landFanImgs]

    //Set air share images
    this.airCtx = this.airCanvas.getContext("2d")

    this.air1Img = new Image()
    this.air1Img.onload = function() {
      that.updateAirCanvas()
    }
    this.air1Img.src = imgAir1BG

    this.air2Img = new Image()
    this.air2Img.src = imgAir2BG

    this.air3Img = new Image()
    this.air3Img.src = imgAir3BG

    this.airFan1Img = new Image()
    this.airFan1Img.src = imgFanAir1BG

    this.airFan2Img = new Image()
    this.airFan2Img.src = imgFanAir2BG

    this.airFan3Img = new Image()
    this.airFan3Img.src = imgFanAir3BG

    this.airImgs = []
    this.airImgs.push({ img: this.air1Img, textY: 540 })
    this.airImgs.push({ img: this.air2Img, textY: 540 })
    this.airImgs.push({ img: this.air3Img, textY: 548 })

    this.airFanImgs = []
    this.airFanImgs.push({ img: this.airFan1Img, textY: 519 })
    this.airFanImgs.push({ img: this.airFan2Img, textY: 515 })
    this.airFanImgs.push({ img: this.airFan3Img, textY: 515 })

    this.airShareData = [this.airImgs, this.airFanImgs]

    this.updateTO = null

    this.resize()
    window.addEventListener("resize", this.resize.bind(this))
  }

  resize() {
    if (window.innerWidth <= 750) {
      this.sliderWidth = 245
    } else if (window.innerWidth <= 1024) {
      this.sliderWidth = 564
    } else {
      this.sliderWidth = 700
    }

    this.setState({ width: window.innerWidth })

    this.forceUpdate()
  }

  updateWaterCanvas() {
    this.waterCtx.clearRect(0, 0, 1080, 1080)
    this.waterCtx.drawImage(
      this.waterShareData[this.state.scaleIndex][this.state.waterIndex].img,
      0,
      0,
      1080,
      1080
    )
    this.waterCtx.font = "110px Druk"
    this.waterCtx.fillStyle = "#fc8cf3"
    this.waterCtx.fillText(
      this.stat3El
        .querySelector(".stat-value")
        .innerHTML.replace(/[^0-9.,]/g, ""),
      500,
      this.waterShareData[this.state.scaleIndex][this.state.waterIndex].textY
    )
    var data = this.waterCanvas.toDataURL("image/png")
    this.waterImage.src = data
    if (this.currX / this.sliderWidth > 0.002) {
      this.waterDownload.setAttribute("href", data)
      this.waterDownload.setAttribute("download", "ImpossibleImpactWater")
    } else {
      this.waterDownload.setAttribute("href", "#")
      this.waterDownload.removeAttribute("download")
    }
  }

  updateLandCanvas() {
    this.landCtx.clearRect(0, 0, 1080, 1080)
    this.landCtx.drawImage(
      this.landShareData[this.state.scaleIndex][this.state.landIndex].img,
      0,
      0,
      1080,
      1080
    )
    this.landCtx.font = "110px Druk"
    this.landCtx.fillStyle = "#00dda5"
    this.landCtx.fillText(
      this.stat2El
        .querySelector(".stat-value")
        .innerHTML.replace(/[^0-9.,]/g, ""),
      500,
      this.landShareData[this.state.scaleIndex][this.state.landIndex].textY
    )
    var data = this.landCanvas.toDataURL("image/png")
    this.landImage.src = data
    if (this.currX / this.sliderWidth > 0.002) {
      this.landDownload.setAttribute("href", data)
      this.landDownload.setAttribute("download", "ImpossibleImpactLand")
    } else {
      this.landDownload.setAttribute("href", "#")
      this.landDownload.removeAttribute("download")
    }
  }

  updateAirCanvas() {
    this.airCtx.clearRect(0, 0, 1080, 1080)
    this.airCtx.drawImage(
      this.airShareData[this.state.scaleIndex][this.state.airIndex].img,
      0,
      0,
      1080,
      1080
    )
    this.airCtx.font = "110px Druk"
    this.airCtx.fillStyle = "#3141EB"
    this.airCtx.fillText(
      this.stat1El
        .querySelector(".stat-value")
        .innerHTML.replace(/[^0-9.,]/g, ""),
      500,
      this.airShareData[this.state.scaleIndex][this.state.airIndex].textY
    )

    var data = this.airCanvas.toDataURL("image/png")
    this.airImage.src = data
    if (this.currX / this.sliderWidth > 0.002) {
      this.airDownload.setAttribute("href", data)
      this.airDownload.setAttribute("download", "ImpossibleImpactAir")
    } else {
      this.airDownload.setAttribute("href", "#")
      this.airDownload.removeAttribute("download")
    }
  }

  animateIn() {
    this.audioEl.muted = true
    this.audioEl.loop = true
    this.audioEl.play()
    TweenMax.set(this.sliderViewEl, { autoAlpha: 1 })
    TweenMax.staggerFromTo(
      this.sliderViewEl.querySelectorAll(".anim"),
      1,
      { opacity: 0, y: 30 },
      { y: 0, opacity: 1, ease: Expo.easeOut, delay: 0.5 },
      0.05
    )
  }

  onClickStat(el) {
    this.stat1El.classList.remove("active")
    this.stat2El.classList.remove("active")
    this.stat3El.classList.remove("active")
    el.classList.add("active")
  }

  onClickArrow() {
    this.tooltipEl.classList.add("edit")
    this.inputEl.focus()
  }

  onClickDropdown(index, val) {
    var that = this
    if (index == 0) {
      this.setState({ airIndex: val })
      this.stat1El.classList.remove("active")
    }
    if (index == 1) {
      this.setState({ landIndex: val })
      this.stat2El.classList.remove("active")
    }
    if (index == 2) {
      this.setState({ waterIndex: val })
      this.stat3El.classList.remove("active")
    }

    setTimeout(function() {
      that.updateWaterCanvas()
      that.updateLandCanvas()
      that.updateAirCanvas()
    }, 300)
  }

  onClickCalculate() {
    var that = this

    var val = this.inputEl.value

    if (this.state.unit == 1) {
      // val = Math.floor(val/4);
      val = val / 4
    }

    if (this.state.unit == 0 && this.state.scaleIndex == 1) {
      // val = Math.round(val/1.33);
      val = val / 1.33
    }

    if (val > this.state.scale) {
      val = this.state.scale
    }

    TweenMax.to(that, 0.5, {
      currX: (val / this.state.scale) * that.sliderWidth,
      ease: Quart.easeOut,
      onUpdate: function() {
        TweenMax.set(that.thumbEl, { x: that.currX })

        that.props.callback(that.currX / that.sliderWidth)
        that.updateValue()
      },
    })

    that.tooltipEl.classList.remove("edit")
    that.tooltipEl.classList.remove("editing")
    that.inputEl.value = ""
  }

  onChangeInput() {
    if (this.inputEl.value.length > 0) {
      this.tooltipEl.classList.add("editing")
    } else {
      this.tooltipEl.classList.remove("editing")
    }
  }

  updateValue() {
    var that = this

    if (this.currX / that.sliderWidth >= 0.25 && !this.audioOn) {
      try {
        if (!this.muteEl.classList.contains("muted")) {
          this.audioEl.muted = false
        }
        this.audioOn = true
      } catch (e) {}
    }

    if (this.currX / that.sliderWidth < 0.25 && this.audioOn) {
      try {
        this.audioEl.muted = true
        this.audioOn = false
      } catch (e) {}
    }

    if (this.state.scaleIndex == 0 && this.state.unit == 0) {
      this.setState({
        value: Math.floor((this.currX / that.sliderWidth) * this.state.scale),
      })
    } else {
      this.setState({
        value: (this.currX / that.sliderWidth) * this.state.scale,
      })
    }
    if (this.updateTO) {
      clearTimeout(this.updateTO)
    }
    this.updateTO = setTimeout(function() {
      that.updateWaterCanvas()
      that.updateLandCanvas()
      that.updateAirCanvas()
      that.updateTO = null
    }, 500)
  }

  onClickMute() {
    if (this.muteEl.classList.contains("muted")) {
      if (this.audioOn) {
        this.audioEl.muted = false
      }
      this.muteEl.classList.remove("muted")
    } else {
      this.audioEl.muted = true
      this.muteEl.classList.add("muted")
    }
  }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  }

  render() {
    return (
      <div
        className="sliderView"
        ref={element => (this.sliderViewEl = element)}
      >
        <div
          className="mute-button"
          ref={element => (this.muteEl = element)}
          onClick={() => {
            this.onClickMute()
          }}
        ></div>
        <audio
          ref={element => (this.audioEl = element)}
          src={audioJungle}
        ></audio>
        <div className="slider-wrapper">
          <h1 className="title anim">measure your impact</h1>

          <div className="slider anim">
            <div className="bg"></div>
            <div className="thumb" ref={element => (this.thumbEl = element)}>
              <div className="circle"></div>
              <div
                className="tooltip"
                ref={element => (this.tooltipEl = element)}
              >
                <div className="arrow-up"></div>
                <div
                  className="calculate"
                  onClick={() => {
                    this.onClickCalculate()
                  }}
                >
                  CALCULATE
                </div>
                <div className="inner">
                  <div
                    className="tooltip-arrow"
                    onClick={() => {
                      this.onClickArrow()
                    }}
                  ></div>
                  <div
                    className="tooltip-label"
                    ref={element => (this.toolTipLabelEl = element)}
                  >
                    {this.state.unit == 0
                      ? this.state.scaleIndex == 1
                        ? this.numberWithCommas(
                            Math.round(this.state.value * 1.33)
                          )
                        : this.numberWithCommas(Math.round(this.state.value))
                      : this.numberWithCommas(Math.floor(this.state.value * 4))}
                    {this.state.value == this.state.scale ? "+" : ""}{" "}
                    {data[this.state.scaleIndex].units[this.state.unit] ==
                    "12 oz. packs"
                      ? "packs"
                      : data[this.state.scaleIndex].units[this.state.unit] == ""
                      ? "burgers"
                      : data[this.state.scaleIndex].units[this.state.unit]}
                  </div>
                  <input
                    className="tooltip-input"
                    onChange={() => {
                      this.onChangeInput()
                    }}
                    onKeyDown={e => {
                      if (e.keyCode == 13) this.onClickCalculate()
                    }}
                    ref={element => (this.inputEl = element)}
                    placeholder="Type amount"
                    type="number"
                    pattern="\\d*"
                  ></input>
                </div>
              </div>
            </div>
          </div>

          <div className="unit-select anim">
            <div className="unit-label">Choose your volume</div>
            <div className="unit-buttons">
              <div
                className={this.state.unit == 0 ? "button active" : "button"}
                onClick={() => {
                  this.setState({ unit: 0 })
                }}
              >
                {data[this.state.scaleIndex].units[0]}
              </div>
              <div
                className={this.state.unit == 1 ? "button active" : "button"}
                onClick={() => {
                  this.setState({ unit: 1 })
                }}
              >
                {data[this.state.scaleIndex].units[1] == ""
                  ? "burgers"
                  : data[this.state.scaleIndex].units[1]}
              </div>
            </div>
          </div>

          <div className="stats">
            <div
              className="title anim"
              ref={element => (this.statsTitleEl = element)}
            >
              {this.state.unit == 0
                ? this.state.scaleIndex == 1
                  ? this.numberWithCommas(Math.round(this.state.value * 1.33))
                  : this.numberWithCommas(Math.round(this.state.value))
                : this.numberWithCommas(Math.floor(this.state.value * 4))}{" "}
              {data[this.state.scaleIndex].units[this.state.unit] ==
              "12 oz. packs"
                ? "packs"
                : data[this.state.scaleIndex].units[this.state.unit]}{" "}
              {data[this.state.scaleIndex].units[this.state.unit] == ""
                ? ""
                : "of"}
              {data[this.state.scaleIndex].units[this.state.unit] != "" ? (
                this.state.width <= 750 ? (
                  <br />
                ) : (
                  " "
                )
              ) : (
                " "
              )}
              impossible
              {data[this.state.scaleIndex].units[this.state.unit] == "" ? (
                this.state.width <= 750 ? (
                  <br />
                ) : (
                  " "
                )
              ) : (
                " "
              )}
              burger
              {data[this.state.scaleIndex].units[this.state.unit] == ""
                ? "s"
                : ""}{" "}
              spares
            </div>
            <div className="tagline anim">
              (when choosing Impossible instead of beef from a cow)
            </div>
            <div className="stats-order">
              <div
                className="stat anim"
                ref={element => (this.stat1El = element)}
                style={
                  data[this.state.scaleIndex].air[this.state.airIndex].eyebrow
                    .length == 0
                    ? { marginTop: "0px" }
                    : {}
                }
              >
                <div
                  className="stat-eyebrow"
                  style={
                    data[this.state.scaleIndex].air[this.state.airIndex].eyebrow
                      .length == 0
                      ? { height: "0px" }
                      : {}
                  }
                >
                  {data[this.state.scaleIndex].air[this.state.airIndex].eyebrow}
                </div>
                <div
                  className="stat-value"
                  onClick={() => {
                    this.onClickStat(this.stat1El)
                  }}
                >
                  {this.numberWithCommas(
                    Math.floor(
                      this.state.value *
                        data[this.state.scaleIndex].air[this.state.airIndex]
                          .coef *
                        data[this.state.scaleIndex].air[this.state.airIndex].dec
                    ) / data[this.state.scaleIndex].air[this.state.airIndex].dec
                  )}{" "}
                  {data[this.state.scaleIndex].air[this.state.airIndex].label}{" "}
                  <span className="arrow-down"></span>
                </div>
                <div className="stat-tagline">
                  {data[this.state.scaleIndex].air[this.state.airIndex].tagline}
                </div>
                <div className="stat-dropdown">
                  <div
                    className={
                      this.state.airIndex == 0
                        ? "stat-dropdown-item active"
                        : "stat-dropdown-item"
                    }
                    onClick={() => {
                      this.onClickDropdown(0, 0)
                    }}
                  >
                    {data[this.state.scaleIndex].air[0].dropdown}
                  </div>
                  <div
                    className={
                      this.state.airIndex == 1
                        ? "stat-dropdown-item active"
                        : "stat-dropdown-item"
                    }
                    onClick={() => {
                      this.onClickDropdown(0, 1)
                    }}
                  >
                    {data[this.state.scaleIndex].air[1].dropdown}
                  </div>
                  <div
                    className={
                      this.state.airIndex == 2
                        ? "stat-dropdown-item active"
                        : "stat-dropdown-item"
                    }
                    onClick={() => {
                      this.onClickDropdown(0, 2)
                    }}
                  >
                    {data[this.state.scaleIndex].air[2].dropdown}
                  </div>
                </div>
              </div>

              <div
                className="stat anim"
                ref={element => (this.stat2El = element)}
                style={
                  data[this.state.scaleIndex].land[this.state.landIndex].eyebrow
                    .length == 0
                    ? { marginTop: "0px" }
                    : {}
                }
              >
                <div className="stat-eyebrow">
                  {
                    data[this.state.scaleIndex].land[this.state.landIndex]
                      .eyebrow
                  }
                </div>
                <div
                  className="stat-value"
                  onClick={() => {
                    this.onClickStat(this.stat2El)
                  }}
                >
                  {this.numberWithCommas(
                    Math.floor(
                      this.state.value *
                        data[this.state.scaleIndex].land[this.state.landIndex]
                          .coef *
                        data[this.state.scaleIndex].land[this.state.landIndex]
                          .dec
                    ) /
                      data[this.state.scaleIndex].land[this.state.landIndex].dec
                  )}{" "}
                  {data[this.state.scaleIndex].land[this.state.landIndex].label}{" "}
                  <span className="arrow-down"></span>
                </div>
                <div className="stat-tagline">
                  {
                    data[this.state.scaleIndex].land[this.state.landIndex]
                      .tagline
                  }
                </div>
                <div className="stat-dropdown">
                  <div
                    className={
                      this.state.landIndex == 0
                        ? "stat-dropdown-item active"
                        : "stat-dropdown-item"
                    }
                    onClick={() => {
                      this.onClickDropdown(1, 0)
                    }}
                  >
                    {data[this.state.scaleIndex].land[0].dropdown}
                  </div>
                  <div
                    className={
                      this.state.landIndex == 1
                        ? "stat-dropdown-item active"
                        : "stat-dropdown-item"
                    }
                    onClick={() => {
                      this.onClickDropdown(1, 1)
                    }}
                  >
                    {data[this.state.scaleIndex].land[1].dropdown}
                  </div>
                  <div
                    className={
                      this.state.landIndex == 2
                        ? "stat-dropdown-item active"
                        : "stat-dropdown-item"
                    }
                    onClick={() => {
                      this.onClickDropdown(1, 2)
                    }}
                  >
                    {data[this.state.scaleIndex].land[2].dropdown}
                  </div>
                </div>
              </div>

              <div
                className="stat anim"
                ref={element => (this.stat3El = element)}
                style={
                  data[this.state.scaleIndex].water[this.state.waterIndex]
                    .eyebrow.length == 0
                    ? { marginTop: "0px" }
                    : {}
                }
              >
                <div className="stat-eyebrow">
                  {
                    data[this.state.scaleIndex].water[this.state.waterIndex]
                      .eyebrow
                  }
                </div>
                <div
                  className="stat-value"
                  onClick={() => {
                    this.onClickStat(this.stat3El)
                  }}
                >
                  {this.numberWithCommas(
                    Math.floor(
                      this.state.value *
                        data[this.state.scaleIndex].water[this.state.waterIndex]
                          .coef *
                        data[this.state.scaleIndex].water[this.state.waterIndex]
                          .dec
                    ) /
                      data[this.state.scaleIndex].water[this.state.waterIndex]
                        .dec
                  )}{" "}
                  {
                    data[this.state.scaleIndex].water[this.state.waterIndex]
                      .label
                  }{" "}
                  <span className="arrow-down"></span>
                </div>
                <div className="stat-tagline">
                  {
                    data[this.state.scaleIndex].water[this.state.waterIndex]
                      .tagline
                  }
                </div>
                <div className="stat-dropdown">
                  <div
                    className={
                      this.state.waterIndex == 0
                        ? "stat-dropdown-item active"
                        : "stat-dropdown-item"
                    }
                    onClick={() => {
                      this.onClickDropdown(2, 0)
                    }}
                  >
                    {data[this.state.scaleIndex].water[0].dropdown}
                  </div>
                  <div
                    className={
                      this.state.waterIndex == 1
                        ? "stat-dropdown-item active"
                        : "stat-dropdown-item"
                    }
                    onClick={() => {
                      this.onClickDropdown(2, 1)
                    }}
                  >
                    {data[this.state.scaleIndex].water[1].dropdown}
                  </div>
                  <div
                    className={
                      this.state.waterIndex == 2
                        ? "stat-dropdown-item active"
                        : "stat-dropdown-item"
                    }
                    onClick={() => {
                      this.onClickDropdown(2, 2)
                    }}
                  >
                    {data[this.state.scaleIndex].water[2].dropdown}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="shareView">
          <h1>share your impact</h1>
          <p>
            Let the world know just how big of an impact you had on the
            environment. Download the badges below and share them across your
            social channels. <b>#ImpossibleImpact</b>
          </p>
          <div className="downloads">
            <div className="download">
              <div className="download-image image-air-miles">
                <canvas
                  className="download-canvas-air"
                  width="1080px"
                  height="1080px"
                  ref={element => (this.airCanvas = element)}
                ></canvas>
                <img
                  className="img-canvas-air"
                  ref={element => (this.airImage = element)}
                />
              </div>
              <a
                href="#"
                download="shareYourImpact"
                ref={element => (this.airDownload = element)}
              >
                <div className="download-button">DOWNLOAD</div>
              </a>
              <div class="download-mobile">Hold to save image</div>
            </div>
            <div className="download">
              <div className="download-image image-land-sf">
                <canvas
                  className="download-canvas-land"
                  width="1080px"
                  height="1080px"
                  ref={element => (this.landCanvas = element)}
                ></canvas>
                <img
                  className="img-canvas-land"
                  ref={element => (this.landImage = element)}
                />
              </div>
              <a
                href="#"
                download="shareYourImpact"
                ref={element => (this.landDownload = element)}
              >
                <div className="download-button">DOWNLOAD</div>
              </a>
              <div class="download-mobile">Hold to save image</div>
            </div>
            <div className="download">
              <div className="download-image image-water-showers">
                <canvas
                  className="download-canvas-water"
                  width="1080px"
                  height="1080px"
                  ref={element => (this.waterCanvas = element)}
                ></canvas>
                <img
                  className="img-canvas-water"
                  ref={element => (this.waterImage = element)}
                />
              </div>
              <a
                href="#"
                download="shareYourImpact"
                ref={element => (this.waterDownload = element)}
              >
                <div className="download-button">DOWNLOAD</div>
              </a>
              <div class="download-mobile">Hold to save image</div>
            </div>
          </div>
        </div>
        <div className="bannerView">
          <h1>understand{this.state.width <= 750 ? <br /> : " "}your impact</h1>
          <p>
            The best and fastest solution to help our planet? It’s simple. Eat
            more meat from plants and less meat from animals.
            <br />
            <br />
            Read the{" "}
            <a
              href="https://impossiblefoods.com/mission/lca-update-2019/"
              target="_blank"
            >
              full Impossible Burger life cycle analysis
            </a>{" "}
            to understand how we calculate environmental savings. For a full
            picture of the impact that beef production has on natural habitats,
            check out these resources:
            <br />
            <br />
            <a
              href="https://www.bloomberg.com/graphics/2018-us-land-use/"
              target="_blank"
            >
              Beef production uses 41% of the contiguous US 
            </a>
            <br />
            <br />
            <a
              href="https://www.nature.com/articles/s41893-020-0483-z"
              target="_blank"
            >
              Water, beef, and the plight of fish in the west
            </a>
            <br />
            <br />
            <a
              href="http://ayhoekstra.nl/pubs/Mekonnen-Hoekstra-2012a.pdf"
              target="_blank"
            >
              The extraordinarily thirsty water footprint of livestock
            </a>
            <br />
          </p>
          <base target="_parent" />
          <a
            style={{ textDecoration: "none" }}
            href="https://impossiblefoods.com/locations/"
          >
            <div className="download-button">FIND IMPOSSIBLE</div>
          </a>
        </div>
        <div className="citationsView">
          <h1>references</h1>

          <a
            href="https://www.epa.gov/sites/production/files/2020-04/documents/ghg-emission-factors-hub.pdf"
            target="_blank"
          >
            GHG emissions from driving and aircraft passenger miles: 2020 EPA
            GHG Emission Factors hub
          </a>
          <br />
          <br />

          <a
            href="https://science.sciencemag.org/content/342/6156/1243092"
            target="_blank"
          >
            Tree density in the Amazon: Hyperdominance in the Amazonian Tree
            Flora
          </a>
          <br />
          <br />

          <a
            href="https://tenniscompanion.org/a-diagram-of-tennis-court-dimensions-layout/"
            target="_blank"
          >
            Tennis court size 2808 sq ft
          </a>
          <br />
          <br />

          <a
            href="http://water.usgs.gov/edu/activity-percapita.php"
            target="_blank"
          >
            Water footprint of a ten minute shower
          </a>
          <br />
          <br />

          <a
            href="https://www.usgs.gov/special-topic/water-science-school/science/water-qa-how-much-water-do-i-use-home-each-day?qt-science_center_objects=0#"
            target="_blank"
          >
            Personal water consumption footprint
          </a>
          <br />
          <br />

          <a
            href="https://en.wikipedia.org/wiki/Monterey_Bay_Aquarium"
            target="_blank"
          >
            Volume of tanks at the Monterey Bay Aquarium
          </a>
          <br />
          <br />
        </div>
      </div>
    )
  }
}

export default SliderView
